module.exports = __webpack_public_path__ + "img/alessandro.7563544d.jpg";